import React from 'react';

import './style.scss';

const AngledSquare = (props) => {
  const { children, size } = props;
  const styles = {
    width: size || null,
    height: size || null,
  };

  return (
    <div className="AngledSquare" style={styles} {...props}>
      <span className="AngledSquare__background" />
      <div className="AngledSquare__content">
        {children}
      </div>
    </div>
  );
};

export default AngledSquare;
